/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbAuthComponent, NbAuthService } from '@nebular/auth';
import { Business } from '../_models/business.model';
import { BusinessService } from '../_services/business.service';
import { Location } from '@angular/common';
import { NbMediaBreakpointsService, NbThemeService } from '@nebular/theme';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { darkenHexColor, hexToRgba } from '../@core/utils/color-utils';

@Component({
  styleUrls: [
    '../../../node_modules/@nebular/auth/components/auth.component.scss',
    './auth.component.scss',
  ],
  templateUrl: './auth.component.html',
})
export class AuthComponent
  extends NbAuthComponent
  implements OnDestroy, OnInit {
  business: Business;
  showSidebarBackdrop: boolean;
  showHeader: boolean = false;

  constructor(
    protected auth: NbAuthService,
    protected location: Location,
    private businessService: BusinessService,
    private themeService: NbThemeService,
    private breakpointService: NbMediaBreakpointsService,
  ) {
    super(auth, location);
  }

  private destroy$: Subject<void> = new Subject<void>();
  ngOnInit(): void {
    this.businessService.current().subscribe((business) => {
      this.business = business;
      document.documentElement.style.setProperty('--primary-color', this.business.primary_color || '#5b53f0');
      document.documentElement.style.setProperty('--primary-light-color', hexToRgba(this.business.primary_color || '#5b53f0', 0.1));
      document.documentElement.style.setProperty('--primary-dark-color', darkenHexColor(this.business.primary_color || '#5b53f0', 20));
      document.documentElement.style.setProperty('--primary-negative-color', this.business.primary_negative_color || '#ffffff');
      document.documentElement.style.setProperty('--secondary-color', this.business.secondary_color || '#009EF3');
      document.documentElement.style.setProperty('--secondary-negative-color', this.business.secondary_negative_color || '#ffffff');
      document.documentElement.style.setProperty('--navbar-color', this.business.navbar_color || '#5b53f0');
      document.documentElement.style.setProperty('--navbar-negative-color', this.business.navbar_negative_color || '#ffffff');
    });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => {
        this.showHeader = isLessThanXl;
      });
  }
}
